import { useEffect, useMemo, useState } from 'react';

import { isLoadingSelector, successSelector } from '@pharmaplan/common';
import { deepEqual } from '@pharmaplan/common/helpers/utils';

import { useAppSelector } from './useAppSelector';

interface IUseDisableProfileSave {
  action: string;
  mutableValues: Record<string, any>;
  initialValue: Record<string, any>;
  replacer?: (obj: Record<string, any>) => Record<string, any>;
}

const useDisableProfileSave = ({ action, mutableValues, initialValue, replacer = (val) =>
  val }: IUseDisableProfileSave) => {
  const [disabled, setDisabled] = useState(false);
  const [initialState, setInitialState] = useState({});

  const success = useAppSelector((state) =>
    successSelector([action], state));
  const loading = useAppSelector((state) =>
    isLoadingSelector([action], state));

  const mutableReplaced = useMemo(() =>
    // eslint-disable-next-line react-hooks/exhaustive-deps
    replacer(mutableValues), [mutableValues]);

  useEffect(() => {
    setInitialState(replacer(initialValue));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialValue]);

  useEffect(() => {
    if (success) {
      setInitialState(mutableReplaced);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [success]);

  useEffect(() => {
    if (loading) {
      setDisabled(false);
    }
  }, [loading]);

  useEffect(() => {
    setDisabled(deepEqual(initialState, mutableReplaced));
  }, [mutableReplaced, initialState]);

  return { disabled };
};

export default useDisableProfileSave;
